var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "global-quicksearch-suggestions" }, [
    _c("p", { staticClass: "typo-light" }, [
      _vm._v(_vm._s(_vm.$t("search.labels.suggestions"))),
    ]),
    _vm._v(" "),
    _c(
      "ul",
      _vm._l(_vm.suggestions, function (item, key) {
        return _c("li", {
          key: item,
          staticClass: "global-quicksearch-suggestions__suggestion",
          class: _vm.selected(key),
          domProps: { innerHTML: _vm._s(_vm.highlightKeyword(item)) },
          on: {
            click: function ($event) {
              return _vm.select(item)
            },
            mouseover: function ($event) {
              return _vm.hover(item)
            },
          },
        })
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }